export const messages = {
  empty: {
    configDiscount: {
      id: 'admin/promotions.form.buy-together.config-discount',
    },
  },
  title: {
    id: 'admin/promotions.form.buy-together.list-index',
  },
  description: {
    id: 'admin/promotions.form.buy-together.trigger.description',
  },
  apply: {
    id: 'admin/promotions.utils.apply',
  },
  cancel: { id: 'admin/promotions.utils.cancel' },
  discount: { id: 'admin/promotions.form.buy-together.discount' },
  minQuantity: { id: 'admin/promotions.form.buy-together.min-quantity' },
  rule: {
    minQuantity: {
      title: {
        id: 'admin/promotions.form.buy-together.min-quantity.title',
      },
      items: {
        id: 'admin/promotions.form.buy-together.min-quantity.description',
      },
    },
  },
}
